/**
     * @desc 创建作品集
categoryList：分类对象数组，参数只要id
paymentTokensList：代币对象数据，参数只要id
featuredImage地址=图片上传接口返回地址
logo地址=featuredImage地址+图片缩放参数
图片缩放参数参考：https://cloud.tencent.com/document/product/1246/45375
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/collection/createCollection', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/collection/createCollection', params);
}
